import moment from 'moment'

const getCurrentDateWithoutTime = () => moment().startOf('day').toDate()

const getDateFromStringWithoutTime = (string, format) =>
    moment(string, format || moment.localeData().longDateFormat('L'))
        .startOf('day')
        .toDate()

const getStringFromDateWithoutTime = (string, format) => {
    const localeFormat = moment.localeData().longDateFormat('L')
    return moment(string, format || localeFormat).format(localeFormat)
}

const getDateWithTime = (date, format) => {
    const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
    return moment(date).format(format || dateTimeFormat)
}

const getDateToBrazilianDefault = (string) => {
    return moment(string).format('L')
    // moment().format('L');    // 05/12/2019
}

const formatDate = (date, format) => {
    return moment(date).format(format)
}

const getIndexOfTheMonthFromString = (string, format) =>
    moment(string, format || moment.localeData().longDateFormat('L')).month()

const getNameOfTheMonthByIndex = (indexOfTheMonth) => {
    switch (indexOfTheMonth) {
        case 0:
            return 'january'
        case 1:
            return 'february'
        case 2:
            return 'march'
        case 3:
            return 'april'
        case 4:
            return 'may'
        case 5:
            return 'june'
        case 6:
            return 'july'
        case 7:
            return 'august'
        case 8:
            return 'september'
        case 9:
            return 'october'
        case 10:
            return 'november'
        case 11:
            return 'december'
        default:
            return false
    }
}

const isValid = (string) => moment(string).isValid()

const getFirstDayOfWeek = (locale) => {
    switch (locale) {
        case 'en-US':
        case 'pt-BR':
            return 1 // Sunday
        case 'es-ES':
            return 2 // Monday
        default:
            return 1
    }
}

const getLastDayOfCurrentMonth = () => {
    return moment().endOf('month').startOf('day').toDate()
}

const getLastDayOfNextMonth = (date, months = 1) => {
    return moment(date).add(months, 'months').endOf('month').startOf('day').toDate()
}

const isSameOrAfter = (date) => {
    return moment().startOf('day').isSameOrAfter(date)
}

const isSameOrBefore = (date) => {
    return moment().startOf('day').isSameOrBefore(date)
}

const getFromNow = (date) => moment(date).fromNow()

export {
    isValid,
    formatDate,
    isSameOrAfter,
    isSameOrBefore,
    getFirstDayOfWeek,
    getLastDayOfNextMonth,
    getLastDayOfCurrentMonth,
    getNameOfTheMonthByIndex,
    getCurrentDateWithoutTime,
    getDateFromStringWithoutTime,
    getStringFromDateWithoutTime,
    getIndexOfTheMonthFromString,
    getDateToBrazilianDefault,
    getDateWithTime,
    getFromNow,
}
